import { DefinitionColonne } from '../../../entites/definition-colonne';

/** Colonnes optionnelles de la liste des bons de travail / soumissions. */
export const COLONNES_DISPONIBLES_BONS_TRAVAIL: DefinitionColonne[] = [
    { champ: 'heuresKm', entete: 'Heures / KM', afficheParDefaut: false }
];
